import React, {useEffect, useState, useContext} from "react";
import {useHistroy} from "react-router-dom";
import permissionService from "../../services/api/permission-group-service.js";
import formValidations from "../../variables/form-validations.js";
import TagInput from "../saas/plan/TagInput";
import UserContext from "../../UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    Alert,
    Spinner,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
    UncontrolledCollapse,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
} from "reactstrap";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import Select from "react-select";
import { useHistory } from "react-router-dom";


const EditPermissionGroup  = (props) =>{
    const history = new useHistory();
    const permissionGroupId = new URLSearchParams(props.location.search).get(
        "permissionGroupId"
    )
    if(!permissionGroupId){
        history.push("/permissions/permission-details");
    }
    const [disabled, setDisabled] = useState(false);
    const [permissionGroup, setPermissionGroup] = useState(false); // change this into false
    const [permissionGroupDescriptionState, setPermissionGroupDescriptionState] = useState("");
    const [permisisonGroupDescriptionError, setPermisisonGroupDescriptionError] = useState("");
    const [permissionGroupNameState, setPermissionGroupNameState] = useState("");
    const [permisisonGroupNameError, setPermisisonGroupNameError] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(true);
    const [permissionsState, setPermissionState] = useState("");
    const [permissionsError, setPermissionsError] = useState("");
    const [alert, setAlert] = useState({ show: false, message: "", type: "" });
    const [formdetails, setFormdetails] = useState({
        permissionGroupId:"",
        permissionGroupName: "",
        permissionGroupDescription:"",
        permissions:"",
    });
    const [verticalTab, setVerticalTab] = useState("");
    const [defaultCheckedPermission, setdefaultCheckedPermission] = useState([])
    const [checkedPermissions, setcheckedPermissions] = useState([]);
    // const [codeList, setCodeList] = useState([]);
    const context = useContext(UserContext);

    const [permissionLookUp, setPermissionLookUp] = useState([]);
    // const [permissionGroupCode, setPermissionGroupCode] = useState("");
    useEffect(
        ()=>{
            (async () => {
                // api for permissions
                let response = await permissionService.getPermissions();
                if(response && response.data){
                    setPermissionLookUp(response.data);
                    // Set first tab as default
                    const firstKey = Object.keys(response.data)[0];
                    if(firstKey && verticalTab === "") {
                        setVerticalTab(firstKey);
                    }
                }
                // api for loading permission Group details
                // let permissionGroupData = await permissionService.getPermissionGroupDetails(permissionGroupId);
                // // console.log(permissionGroupData)
                // defaultChecked();
                // if(permissionGroupData.status && permissionGroupData.data){
                //     setPermissionGroup(permissionGroupData.data);
                //     setFormdetails({
                //         ...formdetails,
                //         permissionGroupId: permissionGroupData.data.permissionGroupId,
                //         permissionGroupName: permissionGroupData.data.name,
                //         permissions: permissionGroupData.data.permissions,
                //     });
                // }

            })();
        },[]);

    
        useEffect(()=>{
            (async ()=> {
                
                let permissionGroupData = await permissionService.getPermissionGroupDetails(permissionGroupId);
                // console.log(permissionGroupData)
                if(permissionGroupData.status && permissionGroupData.data){
                    setPermissionGroup(permissionGroupData.data);
                    
                    let list = [...defaultCheckedPermission];
                    const response = await permissionService.getSelectedPermissionList(permissionGroupId);
                    
                    if(response.status && response.data != ""){
                        setdefaultCheckedPermission(response.data);
                        setFormdetails({
                            ...formdetails,
                            permissionGroupId: permissionGroupData.data.permissionGroupId,
                            permissionGroupName: permissionGroupData.data.name,
                            permissionGroupDescription: permissionGroupData.data.description,
                            permissions: response.data
                        });
                        setcheckedPermissions(response.data);
                        console.log("checkedpermissions ",response.data)
                        setPermissionState("has-success");
                        setPermissionsError("");

                    }
                }
            })();
        },[])
    const validatePemrissionGroupName = ()=>{
        if(formdetails.permissionGroupName.trim() === ""){
            setPermissionGroupNameState("has-danger");
            setPermisisonGroupNameError("Permission Group Name is required!");
            return false;
        }
        setPermissionGroupNameState("has-success");
        return true;
    };

    const validatePermissionGroupDescription = ()=>{
        
        if(formdetails.permissionGroupDescription === ""){
            setPermissionGroupDescriptionState("has-danger");
            setPermisisonGroupDescriptionError("Permission Group Name is required!");
            return false;
        }
        setPermissionGroupDescriptionState("has-success");
        return true;
    };

    const handleSubmit = (e) => {
        validateForm();
        e.preventDefault();
    }

    const handlePermissionGroupNameChange = (event) => {
        // console.log("in name: ",event.target.value)
        setFormdetails({
            ...formdetails,
            permissionGroupName: event.target.value,
        })
        setPermissionGroupNameState("has-success");
        setPermisisonGroupNameError("");
    }

    const handlePermissionGroupDescriptionChange = (event) => {
        console.log("in name: ",event.target.value)
        setFormdetails({
            ...formdetails,
            permissionGroupDescription: event.target.value,
        })
        setPermissionGroupDescriptionState("has-success");
        setPermisisonGroupDescriptionError("");
    }
   
    const handlePermissionsChange = (event) => {
        console.log(event.target.value)
        let updateList = [...checkedPermissions];
        if(event.target.checked){
            updateList = [...checkedPermissions,event.target.value];
        }
        else{
            updateList.splice(checkedPermissions.indexOf(event.target.value),1);
        }
        console.log(updateList);
        setcheckedPermissions(updateList);
        setFormdetails({
            ...formdetails,
            permissions: updateList
        })
        setPermissionState("has-success");
        setPermissionsError("");
        // make new state for permisisons array and push every permission in permission array 
    }

    // const handlePermissionsCode = (code)=> {
    //     // update codes array using push function in formdetails
    //     let updateList = [...codeList];
    //     if(code != ""){
    //         updateList = [...codeList, code];
    //     }
    //     else{
    //         updateList = [...codeList]
    //     }
    //     console.log(updateList)
    //     setCodeList(updateList);
    // }

    const validatePermissions = () => {
        // console.log("permissions: ",formdetails.permissions.length);
        if(formdetails.permissions.length <= 0){
            setPermissionState("has-danger");
            setPermissionsError("Select At least one permission");
            return false;
        }
        // console.log("permissions", formdetails.permissions)
        setPermissionState("has-success");
        return true;
    }

    const validateForm = async () => {
        // setFormdetails({...formdetails});
        let permissionGroupNameValidation = validatePemrissionGroupName();
        let permissionsValidation = validatePermissions();
        // let permissionGroupDescriptionValidation = validatePermissionGroupDescription();
        // console.log("in form",formdetails)
        if(permissionGroupNameValidation && permissionsValidation  && !disabled){
            setShowLoader(true);
            setShowSaveButton(false);
            // console.log("formdetails: ",formdetails);
            let savePermissionGroup = await permissionService.savePermissionGroup({...formdetails});
            // console.log(savePermissionGroup);
            setDisabled(true);
            // if(!savePermissionGroup.status && savePermissionGroup.error.errorCode === 403){
            //     context.setIsAuthorized(context);
            // }
            if(savePermissionGroup.status){
                setTimeout(()=>{
                    setShowLoader(false);
                    setAlert({
                        show:true,
                        type:"success",
                        message:"Role saved successfully!"
                    });
                },1000);

                setTimeout(()=>{
                    setAlert({
                        show:false,
                        type:"",
                        message:""
                    });
                },3000);

                setTimeout(()=>{
                    history.push("/permissions/permission-details");
                },2000);
            }
            else{
                setTimeout(()=>{
                    setShowLoader(false);
                    setShowSaveButton(true);
                    setAlert({
                        show:true,
                        type:"danger",
                        message: "Role could not be saved, Please try again."
                    });
                },1000);
                setAlert(()=>{
                    setAlert({show:false, type:"", message:""});
                },3000);
            }
        }
    };

    var navItems = [];
    
    Object.keys(permissionLookUp).forEach((key) => {
 
        navItems.push(<NavItem key={key}>
            <NavLink
                data-toggle="tab"
                href={"#" + key}
                role="tab"
                className={
                    (verticalTab === key) ? "active bg-#66615b text-white" : ""
                }
                style={{
                    cursor: 'pointer',
                    backgroundColor: verticalTab === key ? '#66615b' : 'transparent',
                    color: verticalTab === key ? 'white' : '#66615b',
                    borderColor: verticalTab === key ? '#66615b' : '#dee2e6'
                }}
                onClick={() => {
                    setVerticalTab(key);
                }}
                >
                {permissionLookUp[key].classifierName}
            </NavLink>
        </NavItem>);
    });

    // Generate tab panes based on current active tab
    const renderTabPanes = () => {
        const tabPanes = [];
        
        Object.keys(permissionLookUp).forEach((key) => {
            const permission = permissionLookUp[key].permissions;
            const permissionElements = [];
            const permissionCount = Object.keys(permission).length;
            
            // Calculate number of columns based on permission count
            let columns = 1;
            if (permissionCount > 15) {
                columns = 4;
            } else if (permissionCount > 10) {
                columns = 3;
            } else if (permissionCount > 5) {
                columns = 2;
            }
            
            Object.keys(permission).forEach((data) => {
                const isChecked = checkedPermissions.includes((permission[data].value));
                permissionElements.push(
                    <div key={permission[data].value} style={{
                        padding: '12px 15px',
                        border: isChecked ? '2px solid #007bff' : '1px solid #dee2e6',
                        borderRadius: '6px',
                        backgroundColor: isChecked ? '#f0f8ff' : '#ffffff',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: isChecked ? '0 2px 6px rgba(0,123,255,0.15)' : '0 1px 3px rgba(0,0,0,0.1)',
                        marginBottom: '8px'
                    }}
                    onClick={() => {
                        const event = {
                            target: {
                                checked: !isChecked,
                                value: permission[data].value
                            }
                        };
                        handlePermissionsChange(event);
                    }}
                    >
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <Label style={{
                                fontSize: '13px',
                                fontWeight: '500',
                                color: isChecked ? '#007bff' : '#495057',
                                margin: 0,
                                cursor: 'pointer',
                                flex: 1
                            }}>
                                {permission[data].label}
                            </Label>
                            <Input 
                                type="checkbox" 
                                name={permission[data].value} 
                                id={permission[data].value} 
                                checked={isChecked} 
                                value={permission[data].value} 
                                onChange={handlePermissionsChange} 
                                style={{
                                    marginLeft: '8px',
                                    transform: 'scale(1.1)',
                                    accentColor: '#007bff'
                                }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    </div>
                );
            });
            
            tabPanes.push(
                <TabPane key={key} tabId={key} role="tabpanel">
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${columns}, 1fr)`,
                        gap: '15px',
                        padding: '10px'
                    }}>
                        {permissionElements}
                    </div>
                </TabPane>
            );
        });
        
        return tabPanes;
    };


        

    return(
        <>
            <div className="content">
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="12">
                            <Card className="card-signup text-center">
                                <CardHeader>
                                    <CardTitle tag="h4">Edit Role</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    {permissionGroup ?(
                                        <Form
                                            className="form-horizontal form"
                                            action=""
                                            id=""
                                            method = "POST"
                                            onSubmit={handleSubmit}
                                        >
                                            <Row>
                                                <Label sm="2">Role Name<span className="text-danger">*</span></Label>
                                                <Col sm="7">
                                                    <FormGroup
                                                        className={permissionGroupNameState}
                                                    >
                                                        <Input
                                                            name="name"
                                                            id="name"
                                                            type="text"
                                                            value={formdetails.permissionGroupName}
                                                            onChange={handlePermissionGroupNameChange}
                                                        />
                                                        {permissionGroupNameState === "has-danger" ?
                                                            (
                                                                <label className="error">
                                                                    {permisisonGroupNameError}
                                                                </label>
                                                            ): null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Label sm="2">Role Description</Label>
                                                <Col sm="7">
                                                    <FormGroup
                                                    >
                                                        <Input
                                                            name="name"
                                                            id="name"
                                                            type="text"
                                                            value={formdetails.permissionGroupDescription}
                                                            onChange={handlePermissionGroupDescriptionChange}
                                                        />
                                                      
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <h5> Permissions</h5>
                                            </Row>


                                            <Card>
                                                <CardBody>

                                                    <Row className={permissionsState}>
                                                        <Col md="3">
                                                            <div className="nav-tabs-navigation verical-navs p-0">
                                                                <div className="nav-tabs-wrapper">
                                                            
                                                                    <Nav className="flex-column nav-stacked nav nav-tabs">
                                                                        {navItems}
                                                                    </Nav>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col md="9">
                                        
                                                            <TabContent id="vertical-tab-content" style={{ 'height': '700px', 'overflow-y': 'scroll','fontSize':"20px" }} activeTab={verticalTab}>
                                                                {renderTabPanes()}     
                                                            </TabContent>
                                                            
                                                        </Col>
                                                    </Row>
                                                    {permissionsState === "has-danger" ? (<label className="error" style={{ color: "red" }}>
                                                        {permissionsError}
                                                    </label>
                                                    ) : null}
                                                </CardBody>
                                            </Card>
                                            {/* <Row className={permissionsState}>
                                                <div>
                                                    {permissionLookUp.map(data=><>
                                                        
                                                        <Button 
                                                            color="primary" 
                                                            id="toggler1" 
                                                            style={{ marginBottom: '1rem' }} 
                                                            // onClick={getPermissions}
                                                        >
                                                            {data.classifierName}
                                                            
                                                        </Button>

                                                        <UncontrolledCollapse toggler="#toggler1">
                                                        <Card>
                                                            <CardBody>
                                                                <Form>
                                                                    
                                                                    {defaultCheckedPermission && defaultCheckedPermission.length ? data.permissions.map(permission=>(
                                                                        // <Input type="checkbox" label={data[0].permissions.label} value={data[0].permissions.value}>{data[0].permissions.label}</Input>
                                                                        <FormGroup >
                                                                                    {/* {console.log(key2)}
                                                                                    {console.log(data2.label)} */}
                                                                                    {/* <Label >{permission.label}</Label>
                                                                                    {console.log("permission List: ",defaultCheckedPermission)}
                                                                                    {console.log("value: ",permission.value)}
                                                                                    {console.log(defaultCheckedPermission.includes(String(permission.value)) ? true : false)}
                                                                                    <Input type="checkbox" id={permission.value} defaultChecked={defaultCheckedPermission.includes(String(permission.value)) ? true : false} value={permission.value} onChange={handlePermissionsChange}></Input>

                                                                        </FormGroup>

                                                                    )
                                                                    
                                                                    ): null}
                                                                </Form>
                                                            </CardBody>
                                                        </Card>
                                                    </UncontrolledCollapse>
                                                    </>)}
                                                    
                                                </div>
                                                    {permissionsState === "has-danger" ?(<label className="error">
                                                                    {permissionsError}
                                                                </label>
                                                        ): null}
                                            </Row> */}
                                                
                                                {/* <Row className={permissionsState}>
                                                <Card>
                                                    <CardBody>
                                                        <Accordion allowZeroExpanded={true}>
                                                        {permissionLookUp.map(data => <>
                                                            <AccordionItem key={data.code}>
                                                                <AccordionItemHeading className="square border">
                                                                    
                                                                    <AccordionItemButton 
                                                                         color="primary"
                                                                         id="toggler1"
                                                                         style={{ marginBottom: '1rem',textAlign:"left" }}
                                                                    >
                                                                            {data.classifierName}
                                                                    </AccordionItemButton>
                                                                </AccordionItemHeading>
                                                                <AccordionItemPanel>
                                                                    <Form >

                                                                        { defaultCheckedPermission && defaultCheckedPermission.length ? data.permissions.map(permission => ( 
                                                                            
                                                                            <FormGroup className="text-left">  */}
                                                                                {/* {console.log(key2)}
                                                                                    {console.log(data2.label)} */}
                                                                                {/* <Label >{permission.label}</Label>
                                                                                <Input type="checkbox" id={permission.value} defaultChecked={defaultCheckedPermission.includes(String(permission.value)) ? true : false} value={permission.value} onChange={handlePermissionsChange}></Input>

                                                                            </FormGroup>

                                                                        )

                                                                        ):null}
                                                                    </Form>

                                                                </AccordionItemPanel>
                                                            </AccordionItem>
                                                        </>)}   
                                                        </Accordion>

                                                    </CardBody>
                                                </Card>
                                                {permissionsState === "has-danger" ? (<label className="error" style={{color:"red"}}>
                                                    {permissionsError}
                                                </label>
                                                ) : null}
                                            </Row> */}


                                            <Row>
                                                {showSaveButton?(
                                                    <div>
                                                        <Button 
                                                            className="btn-round"
                                                            color="info"
                                                            type="button"
                                                            onClick={validateForm}
                                                            disabled={disabled}
                                                        >
                                                            Save
                                                        </Button>
                                                        <Button 
                                                            className="btn-round"
                                                            color="danger"
                                                            type="button"
                                                            onClick={(event) => {
                                                                history.push(`/permissions/permission-details`)
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                ):("")}
                                                {
                                                    alert.show?(
                                                        <Alert color={alert.type}>
                                                            {alert.message}
                                                        </Alert>
                                                    ):("")
                                                }
                                                {showLoader?(
                                                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                        <Spinner 
                                                            animation="border"
                                                            role="status"
                                                        >
                                                            <span className="sr-only"></span>
                                                        </Spinner>
                                                    </div>
                                                ):("")}
                                            </Row>

                                        </Form>
                                    ):(
                                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '20px' }}>
                                        <Spinner animation="border" role="status">
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </Spinner>
                                    </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default EditPermissionGroup;